import React from 'react';
import Immutable, { Map } from 'immutable';
import {
  Container,
  WysiwygField,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';
import {
  Paragraph,
  Block, CoreLink, View,
} from '@uncinc/react-drupal-core';

import { useTranslation } from 'react-i18next';

import Video from '../../../../components/Video';
import { BLOCK_NEWSLETTER_SUBSCRIBE_BLOCK_ID } from '../../../../config/constants';
import './style.scss';

const NodeCampaignLandingPageFull = ({ entity, className }) => {
  const { t } = useTranslation();

  const title = entity.getIn(['title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed']);
  const image = entity.getIn(['field_image', 0, 'styles', 'crop_16_9']);
  const linkUrl = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title'], '');
  const secondaryLinkUrl = entity.getIn(['field_link_to_page', 0, 'alias'], entity.getIn(['field_link_to_page', 0, 'uri']));
  const secondaryLinkTitle = entity.getIn(['field_link_to_page', 0, 'title'], '');
  const nodeNid = entity.getIn(['nid', 0, 'value']);
  const mediaBundle = entity.getIn(['field_image', 0, 'bundle'], null);
  const videoItem = entity.getIn(['field_image', 0]);
  const source = videoItem.get('source', videoItem.get('embed', Map()));


  return (
    <article className="NodeCampaignLandingPageFull">

      {/* Start of hero */}
      <div className="NodeCampaignLandingPageFull__hero">
        <Container>
          <div className="row">
            <div className="col-12 col-lg-8 offset-lg-2">
              <div className="NodeCampaignLandingPageFull__title">
                <h1>{title}</h1>
                <div className="NodeCampaignLandingPageFull__body">
                  <WysiwygField
                    property="schema:text"
                    html={body}
                    className="u-word-break u-truncate--5"
                  />
                </div>
                <div className="NodeCampaignLandingPageFull__links">
                  <CoreLink className="Button Button--secondary" to={linkUrl}>
                    {linkTitle}
                    <i className="icon icon-arrow-right" />
                  </CoreLink>
                  { secondaryLinkUrl && (
                    <CoreLink className="Button Button--primary" to={secondaryLinkUrl}>
                      {secondaryLinkTitle}
                      <i className="icon icon-arrow-right" />
                    </CoreLink>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>

      <div className="NodeCampaignLandingPageFull__hero__image">
        <Container>
          <div className="row">
            <div className="col-12">
              <div className="NodeCampaignLandingPageFull__image">
                { mediaBundle && mediaBundle === 'remote_video' ? (
                  <Video
                    source={source}
                    poster={image}
                    className="NodeCampaignLandingPageFull__video"
                    playIcon={<span className="NodeCampaignLandingPageFull__playButton NodeCampaignLandingPageFull__video__poster icon icon-play icon-variant-2" />}
                  />
                ) : (
                  <Image
                    lazyload
                    includeWebP
                    src={image}
                  />
                )}

              </div>
            </div>
          </div>
        </Container>
      </div>

      {/* End of hero */}

      {/* Start of paragraphs */}
      {entity.get('field_paragraphs') ? (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', Immutable.List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            return (
              <Paragraph
                key={`paragraph:${id}`}
                id={id}
                entity={paragraph.get('entity')}
              />
            );
          })}
        </div>
      ) : null}
      {/* End of paragraphs */}

      {/* start of relevant articles */}
      <div className="NodeCampaignLandingPageFull__related_articles">
        <Container>
          <div className="row">
            <div className="col-12">
              <div className="NodeCampaignLandingPageFull__related_articles__title">
                <h2 className="asH1">{t('campaign_article.relevant_articles')}</h2>
              </div>
            </div>
          </div>

          <View
            id="campaign_articles"
            display="block_1"
            args={[nodeNid]}
          />

        </Container>
      </div>

      {/* end of relevant articles */}

      <Block id={BLOCK_NEWSLETTER_SUBSCRIBE_BLOCK_ID} />

    </article>
  );
};

export default NodeCampaignLandingPageFull;
